import { getAccessToken, postTokenVarify } from "../network/padoPost";

export const getAccessTokenApi = (
  hsptCode,
  seqNo,
  hsptName,
  telmdcnFrDh,
  userinfo,
  phonecfg,
  cfg
) => {
  getAccessToken(hsptCode, seqNo, cfg)
    .then((res) => {
      getTokenVarify(
        hsptCode,
        seqNo,
        res.signature,
        hsptName,
        telmdcnFrDh,
        userinfo,
        phonecfg,
        cfg
      );
    })
    .catch((err) => {
      console.log("err :: ", err);
    });
};

const getTokenVarify = (hsptCode, seqNo, token, hsptName, telmdcnFrDh, userinfo, phonecfg, cfg) => {
  postTokenVarify(hsptCode, seqNo, token, cfg)
    .then((res) => {
      // ZoomConnect(seqNo, res.signature, res.object, userinfo, hsptCode);
      if (res.validate != "") {
        zoomAction(
          seqNo,
          res.validate,
          "0",
          userinfo,
          hsptCode,
          hsptName,
          telmdcnFrDh,
          phonecfg,
          cfg
        );
        // getZoomTokenApi(hsptCode, seqNo);
      } else {
        alert("올바르지 않은 접근입니다.");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const zoomAction = (
  seqNo,
  signature,
  object,
  userinfo,
  hsptCode,
  hsptName,
  telmdcnFrDh,
  phonecfg,
  cfg
) => {
  // if (checkMobile === "IOS") {
  if (phonecfg.phoneOS === "IOS") {
    if (parseInt(phonecfg.version.split(".")[2]) > 35) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "openNftf",
        data: JSON.stringify(
          putJsonData(seqNo, signature, object, userinfo, hsptCode, hsptName, telmdcnFrDh)
        ),
      });
    } else {
      webkit.messageHandlers.openNftf.postMessage({
        data: JSON.stringify(
          putJsonData(seqNo, signature, object, userinfo, hsptCode, hsptName, telmdcnFrDh)
        ),
      });
    }
  } else {
    window.java.openNftf(
      JSON.stringify(
        putJsonData(seqNo, signature, object, userinfo, hsptCode, hsptName, telmdcnFrDh)
      )
    );
  }
};

const putJsonData = (orderKey, signature, object, userinfo, hsptCode, hsptName, telmdcnFrDh) => {
  return {
    hsptCode: hsptCode,
    orderKey: orderKey,
    signature: signature ? signature : "",
    name: userinfo.userName,
    command: "wn222",
    hospitalName: hsptName,
    telmdcnFrDh: telmdcnFrDh ? telmdcnFrDh : "",
    medicalCloseUrl: "resrvList",
  };
};
